import {styled} from "@mui/material/styles";

export const LoginBlock = styled("div")`
  background-color: #fff;
  height: 100vh;
  display: flex;
  align-items: center;
`;


